export const defaultProps = {
  error: '',
  success: '',
};



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/SuccessOrErrorAlert/SuccessOrErrorAlert.common.js